import { withFormsy } from 'formsy-react'
import Checkbox from 'shared/components/Checkbox'

const FormsyCheckbox = ({ errorMessage, setValue, onChange, name, required, label, children }) => {
    const changeValue = event => {
        setValue(event.target.checked)
        if (onChange) {
            onChange(event)
        }
    }

    return (
        <div>
            <Checkbox required={required} name={name} onChange={changeValue} className="m-0" label={label}>
                {children}
            </Checkbox>
            <span className="small text-red">{errorMessage}</span>
        </div>
    )
}

export default withFormsy(FormsyCheckbox)
